export function getProductHtml(product, serial, reference) {
    const applicationProperties = require('../../../../applicationProperties.json'),
            productImageUrl = applicationProperties.productImageUrl,
            productDefaultImage = applicationProperties.productDefaultImage,
            contextPath = $('meta[name=context-path]').attr('content').trim(),
            discount = Number(product.dis),
            averageRating = Number(product.averageRating),
            fullStar = Math.floor(averageRating),
            halfStar = (averageRating % 1 != 0 ? 1 : 0),
            emptyStar = 5 - fullStar - halfStar;
    let price;
    if (product.superDealStatus != null && product.superDealStatus === true && product.dealPrice != null) {
        price = product.dealPrice;
    } else {
        price = product.prc;
    }
    let htmlUpper = `
        <div class="book-list-wrapper
        ${product.productOrderType === 'BACKORDER' ? ' back-order' : ''}
        ${product.productOrderType === 'NOTAVAILABLE' ? ' not-available' : ''}
        ${product.productOrderType === 'GIFTVOUCHER' ? ' gift-voucher' : ''}
        ${product.productOrderType === 'PREORDER' ? ' pre-order' : ''}"
        >
        <a href="${contextPath}/electronics/${product.id}/${product.nameUrl}?ref=${reference}">
            <div class="book-img">
                <img src="${productDefaultImage}" data-lazy="${productImageUrl}/130X186/${product.av}" alt="${product.nm} image" />

                ${(discount > 0 && discount < 25) ? `<div class="discount-badge-common badge-common"><p>${discount <= 9 ? '0' : ''}${discount}</p></div>` : ''}
                ${discount >= 25 ? `<div class="discount-badge-common badge-common"><p>${discount}</p></div>` : ''}

                ${(product.productOrderType === 'PREORDER') ? `<div class="pre-order-badge"></div>` : ''}
                ${(product.productOrderType === 'NOTAVAILABLE') ? `<div class="out-of-stock-badge"></div>` : ''}

                ${(product.productOrderType === 'NORMAL') ? `
                    <div class="cart-btn-area">
                        <button class="book-wrapper-cart-btn js--add-to-cart" product-id="${product.id}" onClick="ecomEventEmit('add_to_cart', 'RokElectronicProduct', '${product.id}', '${product.categoryId == null ? 0 : product.categoryId}', '${product.prc}');ga('send', 'event', 'Electronics_ProductList', 'Click', 'ProductList-Click_on_Electronics_ProductList_AddToCart_Button-Click');">
                            Add to Cart
                        </button>
                    </div>` : ''
                }
            </div>

            <div class="book-text-area text-center">
                <h4 class="product-title">${product.nm}</h4>
                <div class="product-review-rating d-flex justify-content-center align-items-center">
    `;

    let htmlStar = '';

    if (product.averageRating > 0) {
        for (let i = 0; i < product.productRatingProducer.fullStarToDraw; i++) {
            htmlStar += '<span class="ion-ios-star"></span>';
        }

        for (let i = 0; i < product.productRatingProducer.halfStarToDraw; i++) {
            htmlStar += '<span class="ion-ios-star-half"></span>';
        }

        for (let i = 0; i < product.productRatingProducer.maximumBlankStarToDraw; i++) {
            htmlStar += '<span class="ion-ios-star-outline"></span>';
        }
    }

    let htmlLower = `
                    ${product.numberOfRating > 0 ? `<p class="product-rating ml-1">(${product.numberOfRating})</p>` : ''}
                </div>
                <p class="product-price">
                    TK. ${price}
                    ${discount > 13 ? `<span class="price-off">(${Math.round(discount)}% Off)</span>` : ''}
                </p>
                <p class="product-brand">Brand: <span>${product.brandName}</span></p>
            </div>
            <div class="home-details-btn-wrapper">
                <a class="btn home-details-btn btn-block" href="${contextPath}/electronics/${product.id}/${product.nameUrl}?ref=rc1_p${serial}_pr${reference}">
                    View Details
                </a>
            </div>
        </a>
    </div>`;

    return htmlUpper + htmlStar + htmlLower;
}